const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_protected/leaderboard.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { DEFAULT_RANGE, RANGES } from "@circle-react/components/Leaderboard/DashboardCompass/Table/constants";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { loadMobileLeaderboardContent, preloadMobilePage } from "@/react/components/Mobile/utils/mobilePageLoaders";
const periodValues = Object.keys(RANGES) as Range[];
const leaderboardSearchSchema = z.object({
  period: z.enum(periodValues).catch(DEFAULT_RANGE)
});
export const Route = createFileRoute("/_protected/leaderboard")({
  validateSearch: leaderboardSearchSchema,
  loader: preloadMobilePage(loadMobileLeaderboardContent),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});